<template>
  <div class="main-box">
    <el-form class="form-inline" :inline="true">
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入名称" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="search.menu_id" placeholder="请选择分类" size="small" clearable>
          <el-option
              v-for="item in menuList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="search.vip_type" placeholder="会员折扣" size="small" clearable>
          <el-option label="跟随系统" :value="1"></el-option>
          <el-option label="自定义" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="handleSearch()">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="mg-bt-10">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addGroup()">添加</el-button>
      <el-button type="danger" size="small" icon="el-icon-delete" @click="delGroup()">删除</el-button>
    </div>
    <el-table
        :data="tableData"
        ref="rfTable"
        border
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          align="center"
          width="55">
      </el-table-column>
      <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="100">
      </el-table-column>
      <el-table-column
          prop="title"
          label="标题">
      </el-table-column>
      <el-table-column
          prop="menu_ids_str"
          label="分类"
          align="center"
          width="200">
      </el-table-column>
      <el-table-column
          prop="imgs"
          label="图片"
          align="center"
          width="120">
        <template slot-scope="scope">
          <el-avatar shape="square" :size="60" fit="contain" :src="scope.row.img"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
          prop="price"
          label="价格"
          align="center"
          width="100">
      </el-table-column>
      <el-table-column
          prop="vip_type"
          label="会员折扣"
          align="center"
          width="100">
        <template slot-scope="scope">
          {{ scope.row.vip_type == 2 ? '自定义' : '跟随系统' }}
        </template>
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="old_price"-->
<!--          label="原价"-->
<!--          align="center"-->
<!--          width="120">-->
<!--      </el-table-column>-->
      <el-table-column
          prop="stock"
          label="库存"
          align="center"
          width="100">
      </el-table-column>
      <el-table-column
          prop="status"
          label="上架状态"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-switch :value="scope.row.is_onsale==1" @change="changeSale(scope.row.id,scope.row.is_onsale==1?0:1)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="rec_time"
          label="推荐状态"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-switch :value="scope.row.rec_time>0" @change="changeRec(scope.row.id,scope.row.rec_time>0?0:1)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
          prop="ordering"
          label="排序"
          align="center"
          width="80">
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="添加时间"
          align="center"
          width="140">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editGroup(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
  </div>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      info: false,
      isOpen: false,
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: '',
        menu_id: '',
        vip_type: ''
      },
      brandList: [],
      menuList: [],
      tableData: [],
    };
  },
  created() {
    this.getMenuList();
    this.getList();
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisiable);
  },
  computed: {},
  methods: {
    handleVisiable(e) {
      if(this.isOpen && e.target.visibilityState === 'visible') {
        this.isOpen = false
        this.getList()
      }
    },
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        menu_id: that.search.menu_id,
        vip_type: that.search.vip_type
      }
      this.$api.goods.goodsIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    getMenuList() {
      this.$api.goods.menuList({menu_type: 2}, res => {
        if (res.errcode == 0) {
          this.menuList = res.data
        }
      })
    },
    addGroup() {
      this.isOpen = true
      window.open('/goods/add')
    },
    editGroup(item) {
      this.isOpen = true
      window.open('/goods/add?id='+item.id)
    },
    changeSale(id,status) {
      this.$api.goods.goodsShenhe({id: id, is_onsale: status}, res => {
        if (res.errcode == 0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    changeRec(id,status) {
      this.$api.goods.goodsRec({id: id, is_rec: status}, res => {
        if (res.errcode == 0) {
          this.success(res.errmsg)
          this.getList()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    delGroup() {
      var that = this
      var sel = this.$refs.rfTable.selection
      if (sel.length < 1) {
        that.tips('请选择删除项')
        return false
      }
      var ids = []
      sel.forEach(function (item) {
        ids.push(item.id)
      })
      this.$confirm('确认要删除这些数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.goods.goodsDel({ids: ids}, function (res) {
          if (res.errcode == 0) {
            that.success('删除成功')
            that.getList()
          } else {
            that.fail(res.errmsg)
          }
        })
      }).catch(() => {

      });
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
